import { AppUserRole } from "../../types/roles";

export const isMarketManager = (role?: string): boolean => {
  return role === AppUserRole.MarketManager;
};

export const isAreaManager = (role?: string): boolean => {
  return role === AppUserRole.AreaManager;
};

export const isWorker = (role?: string): boolean => {
  return role === AppUserRole.Worker;
};

export const isTenantAdmin = (role?: string): boolean => {
  return role === AppUserRole.TenantAdmin;
};

export const isSystemAdmin = (role?: string): boolean => {
  return role === AppUserRole.SystemAdmin;
};
